/* eslint-disable no-underscore-dangle */
/* eslint-disable radix */
/* eslint-disable eqeqeq */
import cx from 'classnames';
import TagManager from 'react-gtm-module';
import useMediaQuery from '@hook/useMediaQuery';
import { useQuery } from '@apollo/client';
import { debuging, features, modules } from '@config';
import { getPriceFromList } from '@core_modules/product/helpers/getPrice';
import { localCompare } from '@services/graphql/schema/local';
import { currencyVar, priceVar } from '@core/services/graphql/cache';
import { getCustomerUid } from '@core_modules/productcompare/service/graphql';
import { getCookies } from '@helper_cookies';
import { useRouter } from 'next/router';
import { useState } from 'react';
import {
    addProductsToCompareList,
    addWishlist as mutationAddWishlist,
    getProductLabel,
    getProductPrice,
    smartProductTabs,
    getAvailableCouponList as getAvailableCouponListLazy,
} from '@core_modules/product/services/graphql';
import { getPickupStoreOMS } from '@core_modules/checkout/services/graphql';
import { getBrands } from '@core_modules/catalog/services/graphql';
import { getCmsBlocks } from '@core_modules/theme/services/graphql';
import { getCmsWidget } from '@core_modules/cms/services/graphql';
import { COLORS } from '@theme_vars';
import _ from 'lodash';
import { brandNamePlaceholder } from '@helpers/env';

const getPrice = (cachePrice, generateIdentifier, dataPrice) => {
    let productPrice = [];

    if (
        cachePrice[generateIdentifier]
        && cachePrice[generateIdentifier].products
        && cachePrice[generateIdentifier].products.items
    ) {
        productPrice = cachePrice[generateIdentifier].products.items;
    } else if (dataPrice && dataPrice.products && dataPrice.products.items) {
        productPrice = dataPrice.products.items;
    }

    return productPrice;
};

const ProductDetailAction = ({
    t,
    slug,
    product, // product.items[productKey]
    productKey,
    isLogin,
    storeConfig,
    useReviewList = false,
    useProductTabs = false,
    useProductImagePreview = false,
    useShareProduct = false,
    useProductRelated = false,
    useProductUpsell = false,
    ssrProduct,
    Content,
    isPdp,
    ...other
}) => {
    const route = useRouter();
    const { isDesktop, isTablet, isMobile } = useMediaQuery();
    const context = isLogin && isLogin == 1 ? { request: 'internal' } : {};
    const item = product.items[productKey];

    const brandId = item?.brand;
    const { data: dataBrands } = getBrands({ pageSize: 100, currentPage: 1 });
    const brandsAttrId = dataBrands?.getBrandList?.items?.find((itemBrand) => itemBrand.attribute_id === brandId);
    const brandName = brandsAttrId?.name;
    const brandUrl = brandsAttrId?.category_url;

    const [getAvailableCouponList, { data: dataCouponList, loading: loadingCouponList }] = getAvailableCouponListLazy();

    const channel_code = storeConfig.oms_channel_code;
    const [getLocation, { data: pickupStoresOMSData, loading: pickupStoresOMSLoading, error: pickupStoresOMSError }] = getPickupStoreOMS({
        variables: {
            filter: {
                sku: { eq: item?.sku },
                is_active: { eq: 1 },
                is_pickup_active: { eq: 1 },
                channel_name: { eq: channel_code },
            },
            pageSize: 200,
            currentPage: 1,
        },
    });
    let oms_store_list = [];
    if (!pickupStoresOMSLoading && pickupStoresOMSData && !pickupStoresOMSError) {
        oms_store_list = pickupStoresOMSData.getTimeLocationList.items;
    }

    let formatted_oms_stores = [];
    if (oms_store_list.length > 0) {
        formatted_oms_stores = oms_store_list.map((itemStore) => {
            const data_store = {
                code: itemStore.loc_code,
                street: itemStore.loc_street,
                city: itemStore.loc_city.label,
                name: itemStore.loc_name,
                region: itemStore.loc_region.label,
                zone: itemStore.loc_zone,
                telephone: itemStore.loc_telephone,
                postcode: itemStore.loc_postcode,
                lat: itemStore.loc_lat,
                long: itemStore.loc_long,
                country_id: itemStore.loc_country_id,
                country: itemStore.loc_country.label,
            };

            return data_store;
        });
    }
    const [openModalStoreList, setOpenModalStoreList] = useState(false);
    const handleOpenModalStoreList = () => {
        setOpenModalStoreList(true);
        getLocation();
    };
    const handleCloseModalStoreList = () => {
        setOpenModalStoreList(false);
    };

    const [openModalProductLabelDesc, setOpenModalProductLabelDesc] = useState(false);
    const [selectedLabelIndex, setSelectedLabelIndex] = useState(null);
    const handleOpenModalProductLabelDesc = (index) => {
        setOpenModalProductLabelDesc(true);
        setSelectedLabelIndex(index);
    };
    const handleCloseModalProductLabelDesc = () => {
        setOpenModalProductLabelDesc(false);
    };

    function generateStyle(stringStyle) {
        return stringStyle.split(';').reduce((acc, curr) => {
            if (!curr) return acc;
            const [key, value] = curr.split(':');
            return { ...acc, [key.trimStart()]: value.trimStart() };
        }, {});
    }

    const currencyCode = item?.price_range?.minimum_price?.regular_price?.currency || 'USD';
    const reviewRef = React.useRef(null);

    // cache currency
    const currencyCache = currencyVar();
    const cachePrice = priceVar();
    const generateIdentifier = slug.replace(/ /g, '-');
    const mount = React.useRef(null);
    const reviewValue = parseInt(item.review.rating_summary, 0) / 20;
    const enableProductCompare = modules.productcompare.enabled;
    const enableWishlist = modules.wishlist.enabled;

    const labels = getProductLabel(storeConfig, { context, variables: { url: slug[0] } });
    const { data: dataCompare, client } = useQuery(localCompare);
    const [addProductCompare] = addProductsToCompareList();
    const [addWishlist] = mutationAddWishlist();
    const [getUid, { data: dataUid, refetch: refetchCustomerUid }] = getCustomerUid();
    const [getProductTabs, { data: dataProductTabs }] = smartProductTabs();
    const [getProdPrice, { data: dataPrice, loading: loadPrice, error: errorPrice }] = getProductPrice(
        storeConfig.pwa || {},
    );

    // PDP Widget
    const { data: dataWidget, loading: loadingWidget } = getCmsWidget({ productId: [parseInt(item?.id)] });
    let widgetContentTop = [];
    let widgetContentAside = [];
    if (dataWidget?.cmsWidget?.data?.length > 0 && !loadingWidget) {
        widgetContentAside = dataWidget.cmsWidget.data.filter((widget) => {
            const firstLayout = widget.layout[0];
            return firstLayout && firstLayout.block_reference === 'content.aside';
        });
        widgetContentTop = dataWidget.cmsWidget.data.filter((widget) => {
            const firstLayout = widget.layout[0];
            return firstLayout && firstLayout.block_reference === 'content.top';
        });
    }

    const { data: dataCmsBankCredit, loading: loadingCmsBankCredit } = getCmsBlocks({ identifiers: 'bank-credit-info-pdp' });
    const cmsBankCredit = dataCmsBankCredit?.cmsBlocks?.items[0].content;

    const [openDialogProductCompare, setOpenDialogProductCompare] = React.useState(false);

    // config
    let enablePopupImage = false;
    if (storeConfig && storeConfig.pwa) {
        enablePopupImage = storeConfig.pwa.popup_detail_image_enable;
    }

    // data tabs
    let expandData = [];
    if (item?.description?.html) {
        expandData = [
            ...expandData,
            {
                title: t('common:label:detail'),
                type: 'html',
                content: item.description.html,
            },
        ];
    }
    if (item.more_info && item.more_info.length > 0) {
        expandData = [
            ...expandData,
            {
                title: t('common:label:moreInfo'),
                type: 'react-component',
                content: (
                    <>
                        <ul className="item-spec-inner">
                            {item.more_info.map((val, idx) => {
                                const isEmpty = val.value.includes('-- Please Select --');
                                return (
                                    <li className={cx('grid', 'grid-cols-2', 'py-3')} key={idx}>
                                        <span className="text-2md text-neutral-black text-lg px-[10px]">{val.label}</span>
                                        <span className="text-2md text-neutral-500 text-lg px-[10px]">{isEmpty ? '-' : val.value}</span>
                                    </li>
                                );
                            })}
                        </ul>
                        <style jsx>
                            {`
                                .item-spec-inner li:nth-child(2n+1) {
                                    background: ${COLORS.neutral[50]};
                                }
                            `}
                        </style>
                    </>
                ),
            },
        ];
    }

    const bannerData = React.useMemo(() => {
        const bannerResult = [];
        if (item.media_gallery.length > 0) {
            // eslint-disable-next-line array-callback-return
            item.media_gallery.map((media) => {
                bannerResult.push({
                    link: '#',
                    imageUrl: media.url,
                    videoUrl: media && media.video_content,
                    imageAlt: media.label,
                });
            });
        } else {
            bannerResult.push({
                link: '#',
                imageUrl: item.image.url,
                videoUrl: '#',
                imageAlt: item.image.label,
            });
        }

        return bannerResult;
    }, [item?.media_gallery, item?.image]);

    const productTab = React.useMemo(() => {
        let productTabResult = {
            tab_1: {
                label: null,
                content: null,
            },
        };
        const productItem = dataProductTabs?.products;
        if (productItem?.items?.length > 0) {
            productTabResult = productItem.items[0].smartProductTabs
                ? productItem.items[0].smartProductTabs
                : {
                    tab_1: {
                        label: null,
                        content: null,
                    },
                };
        }
        return productTabResult;
    }, [dataProductTabs]);

    // Spesific product
    const [spesificProduct, setSpesificProduct] = React.useState({});
    // Customizable Options
    const [customizableOptions, setCustomizableOptions] = React.useState([]);
    const [errorCustomizableOptions, setErrorCustomizableOptions] = React.useState([]);
    // Image preview
    const [openImageDetail, setOpenImageDetail] = React.useState(false);
    const [selectedImgIdx, setSelectedImgIdx] = React.useState(false);
    // Banner
    const [banner, setBanner] = React.useState(bannerData);
    // Option
    const [openOption, setOpenOption] = React.useState(false);
    const [stockStatus, setStockStatus] = React.useState(item.stock_status);
    const [wishlist, setWishlist] = React.useState(false);
    // Show More Short Desc
    const [showShortDesc, setShowShortDesc] = React.useState(false);

    const [additionalPrice, setAdditionalPrice] = React.useState(0);
    const [price, setPrice] = React.useState({
        priceRange: item.price_range,
        priceTiers: item.price_tiers,
        priceDailyDeals: item?.price_daily_deal,
        // eslint-disable-next-line no-underscore-dangle
        productType: item.__typename,
        specialFromDate: item.special_from_date,
        specialToDate: item.special_to_date,
    });

    const [stickyImageSliderTopPosition, setStickyImageSliderTopPosition] = React.useState(null);

    const checkCustomizableOptionsValue = React.useCallback(async () => {
        if (item.options && item.options.length > 0) {
            const requiredOptions = item.options.filter((op) => op.required);
            if (requiredOptions.length > 0) {
                if (customizableOptions.length > 0) {
                    let countError = 0;
                    const optionsError = [];
                    for (let idx = 0; idx < requiredOptions.length; idx += 1) {
                        const op = requiredOptions[idx];
                        const findValue = customizableOptions.find((val) => val.option_id === op.option_id);
                        if (!findValue) {
                            optionsError.push(op);
                            countError += 1;
                        }
                    }
                    if (countError > 0) {
                        await setErrorCustomizableOptions(optionsError);
                        return false;
                    }
                    return true;
                }
                await setErrorCustomizableOptions(requiredOptions);

                return false;
            }
            return true;
        }
        return true;
    }, [item?.options, customizableOptions]);

    const handleWishlist = () => {
        if (isLogin && isLogin == 1) {
            // Brand of product
            const brand_name = dataBrands?.getBrandList?.items?.find((brand) => brand.attribute_id === item.brand)?.name || brandNamePlaceholder();
            // GTM UA dataLayer
            TagManager.dataLayer({
                dataLayer: {
                    event: 'addToWishlist',
                    eventLabel: item.name,
                    label: item.name,
                    ecommerce: {
                        currencyCode,
                        add: {
                            products: [
                                {
                                    name: item.name,
                                    brand: brand_name,
                                    id: item.sku,
                                    price: item.price_range.minimum_price.regular_price.value || 0,
                                    category: item.categories.length > 0 ? item.categories[0].name : '',
                                    list: item.categories.length > 0 ? item.categories[0].name : '',
                                    dimensions4: item.stock_status,
                                },
                            ],
                        },
                    },
                },
            });
            // GA 4 dataLayer
            TagManager.dataLayer({
                dataLayer: {
                    ecommerce: {
                        action: {
                            items: [
                                {
                                    currency: item.price_range.minimum_price.regular_price.currency,
                                    item_name: item.name,
                                    item_brand: brand_name,
                                    item_id: item.sku,
                                    price: item.price_range.minimum_price.regular_price.value || 0,
                                    item_category: item.categories.length > 0 ? item.categories[0].name : '',
                                    item_stock_status: item.stock_status,
                                },
                            ],
                        },
                    },
                    event: 'add_to_wishlist',
                },
            });
            addWishlist({
                variables: {
                    productId: item.id,
                },
            })
                .then(async () => {
                    await setWishlist(!wishlist);
                    await window.toastMessage({ open: true, variant: 'success', text: t('common:message:feedSuccess') });
                    route.push('/wishlist');
                })
                .catch((e) => {
                    window.toastMessage({
                        open: true,
                        variant: 'error',
                        text: debuging.originalError ? e.message.split(':')[1] : t('common:message:feedFailed'),
                    });
                });
        } else {
            window.toastMessage({
                open: true,
                variant: 'warning',
                text: t('catalog:wishlist:addWithoutLogin'),
            });
        }
    };

    const handleSetCompareList = (id_compare) => {
        window.backdropLoader(true);
        const uid_product_compare = getCookies('uid_product_compare');
        const uids = [];
        let uid_customer = '';
        uids.push(id_compare.toString());
        if (isLogin) {
            /* eslint-disable */
            uid_customer = dataUid ? (dataUid.customer.compare_list ? dataUid.customer.compare_list.uid : '') : '';
            /* eslint-enable */
        }
        let isExist = false;
        if (dataCompare && dataCompare.items && dataCompare.items.length > 0) {
            dataCompare.items.map((itemCompare) => {
                if (itemCompare.uid === id_compare.toString()) {
                    isExist = true;
                }
                return null;
            });
        }
        if (!isExist) {
            addProductCompare({
                variables: {
                    uid: isLogin ? uid_customer : uid_product_compare,
                    products: uids,
                },
            })
                .then(async (res) => {
                    client.writeQuery({
                        query: localCompare,
                        data: {
                            item_count: res.data.addProductsToCompareList.item_count,
                            items: res.data.addProductsToCompareList.items,
                        },
                    });
                    if (isLogin) {
                        refetchCustomerUid();
                    }
                    window.backdropLoader(false);
                    window.toastMessage({ open: true, variant: 'success', text: t('common:productCompare:successCompare') });
                    setOpenDialogProductCompare(true);
                    window.reloadCompareQty = true;
                })
                .catch((e) => {
                    window.backdropLoader(false);
                    window.toastMessage({
                        open: true,
                        variant: 'error',
                        text: debuging.originalError ? e.message.split(':')[1] : t('common:productCompare:failedCompare'),
                    });
                });
        } else {
            window.backdropLoader(false);
            window.toastMessage({
                open: true,
                variant: 'error',
                text: t('common:productCompare:existProduct'),
            });
        }
    };

    const handleOption = () => {
        const { productAvailableToCart } = features;
        // eslint-disable-next-line no-underscore-dangle
        if (productAvailableToCart[item.__typename]) {
            setOpenOption(true);
        } else {
            window.toastMessage({
                variant: 'warning',
                text: t('product:productNotAvailable'),
                open: true,
            });
        }
    };

    React.useEffect(() => {
        mount.current = true;
        return () => {
            mount.current = false;
        };
    }, []);

    React.useEffect(() => {
        if (isLogin && !dataUid && modules.productcompare.enabled) {
            getUid();
        }
    }, [isLogin, dataUid]);

    React.useEffect(() => {
        if (mount.current) {
            setPrice({
                priceRange: item.price_range,
                priceTiers: item.price_tiers,
                // eslint-disable-next-line no-underscore-dangle
                productType: item.__typename,
                specialFromDate: item.special_from_date,
                specialToDate: item.special_to_date,
            });
            setBanner(bannerData);
        }
    }, [item]);

    // price
    React.useEffect(() => {
        if (!cachePrice[generateIdentifier]) {
            getProdPrice({
                context: {
                    request: 'internal',
                },
                variables: {
                    url: slug,
                },
            });
        }
    }, [product, slug]);

    // price
    React.useEffect(() => {
        if (dataPrice) {
            const identifier = generateIdentifier;
            const dataTemp = cachePrice;
            dataTemp[identifier] = dataPrice;
            priceVar({ ...cachePrice });
        }
    }, [dataPrice, slug]);

    // product tabs
    React.useEffect(() => {
        if (slug[0] !== '') {
            getProductTabs({
                variables: {
                    filter: {
                        url_key: {
                            eq: slug[0],
                        },
                    },
                },
            });
        }
    }, [slug]);

    React.useEffect(() => {
        if (mount.current && errorCustomizableOptions && errorCustomizableOptions.length > 0) {
            // eslint-disable-next-line consistent-return
            const errorCustomizable = errorCustomizableOptions.filter((err) => {
                const findValue = customizableOptions.find((op) => op.option_id === err.option_id);
                return !findValue;
            });
            setErrorCustomizableOptions(errorCustomizable);
        }
    }, [customizableOptions]);

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const headerHeight = document.getElementById('sticky-header')?.getBoundingClientRect()?.height;
            const headerHeightFallback = document.getElementById('header-inner')?.getBoundingClientRect()?.height;
            if (storeConfig?.pwa?.enabler_sticky_header && ((headerHeight > 0) || (headerHeightFallback > 0))) {
                setStickyImageSliderTopPosition(headerHeight || headerHeightFallback);
            }
        }
    }, []);

    const handleOpenImageDetail = React.useCallback((e, idx) => {
        setOpenImageDetail(!openImageDetail);
        setSelectedImgIdx(idx);
    }, [openImageDetail]);

    // eslint-disable-next-line no-underscore-dangle
    const isAwGiftCard = item.__typename === 'AwGiftCardProduct';
    const priceData = getPriceFromList(
        dataPrice?.products?.items || cachePrice[generateIdentifier]?.products?.items,
        item?.id || null,
    );

    const enableMultiSeller = storeConfig.enable_oms_multiseller === '1' || storeConfig.enable_oms_multiseller === 1;

    // use gql getPrice as priority to get stock status
    const data_product = !_.isEmpty(priceData) ? priceData[0] : item;
    const isInstock = data_product?.only_x_left_in_stock === null
        ? data_product?.stock_status === 'IN_STOCK' : data_product?.only_x_left_in_stock >= 1;

    const longProductDesc = expandData?.filter((itemMagezon) => itemMagezon.type === 'html');

    // voucher list handle
    const [openVoucherList, setOpenVoucherList] = useState(false);
    const handleCloseVoucherList = () => setOpenVoucherList(false);
    const handleOpenVoucherList = () => {
        getAvailableCouponList();
        setOpenVoucherList(true);
    };

    const [copied, setCopied] = useState(false);
    const [textToCopy, setTextToCopy] = useState('');
    const [showFullDesc, setShowFullDesc] = useState({});

    // Function to handle button click and copy text
    const handleCopyVoucherCode = (text) => {
        navigator.clipboard.writeText(text); // Copy text to clipboard
        setTextToCopy(text); // Set text to copy
        setCopied(true); // Set copied to true to show message
        setTimeout(() => {
            setCopied(false); // Reset copied after 2 seconds
        }, 3000);
    };
    const handleToggleDesc = (index) => {
        setShowFullDesc((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    React.useEffect(() => {
        if (priceData) {
            const localStatus = isInstock ? 'IN_STOCK' : 'OUT_OF_STOCK';
            setStockStatus(localStatus);
        }
    }, [priceData, isInstock]);

    const amRewardEnabled = storeConfig?.amrewards_general_enabled;
    const showReward = storeConfig?.amrewards_highlight_product;
    const showLinkRegistration = storeConfig?.amrewards_highlight_registration_link;

    return (
        <Content
            isLogin={isLogin}
            isDesktop={isDesktop}
            isTablet={isTablet}
            isMobile={isMobile}
            enableProductCompare={enableProductCompare}
            enableWishlist={enableWishlist}
            t={t}
            slug={slug}
            reviewValue={reviewValue}
            isAwGiftCard={isAwGiftCard}
            price={price}
            priceData={priceData}
            loadPrice={loadPrice}
            errorPrice={errorPrice}
            banner={banner}
            storeConfig={storeConfig}
            enablePopupImage={enablePopupImage}
            openImageDetail={openImageDetail}
            handleOpenImageDetail={handleOpenImageDetail}
            dataPrice={getPrice(cachePrice, generateIdentifier, dataPrice)}
            additionalPrice={additionalPrice}
            setAdditionalPrice={setAdditionalPrice}
            spesificProduct={spesificProduct}
            setSpesificProduct={setSpesificProduct}
            selectedImgIdx={selectedImgIdx}
            setSelectedImgIdx={setSelectedImgIdx}
            checkCustomizableOptionsValue={checkCustomizableOptionsValue}
            customizableOptions={customizableOptions}
            setCustomizableOptions={setCustomizableOptions}
            errorCustomizable={errorCustomizableOptions}
            setErrorCustomizableOptions={setErrorCustomizableOptions}
            handleWishlist={handleWishlist}
            handleSetCompareList={handleSetCompareList}
            expandData={expandData}
            currencyCache={currencyCache}
            smartProductTabs={productTab}
            useReviewList={useReviewList}
            useProductTabs={useProductTabs}
            useProductImagePreview={useProductImagePreview}
            useShareProduct={useShareProduct}
            handleOption={handleOption}
            openOption={openOption}
            setOpenOption={setOpenOption}
            stockStatus={stockStatus}
            setStockStatus={setStockStatus}
            setBanner={setBanner}
            reviewRef={reviewRef}
            showShortDesc={showShortDesc}
            setShowShortDesc={setShowShortDesc}
            setPrice={setPrice}
            currencyCode={currencyCode}
            useProductRelated={useProductRelated}
            useProductUpsell={useProductUpsell}
            enableMultiSeller={enableMultiSeller}
            data={{
                ...item,
                labels,
            }}
            stickyImageSliderTopPosition={stickyImageSliderTopPosition}
            cmsBankCredit={cmsBankCredit}
            loadingCmsBankCredit={loadingCmsBankCredit}
            brandName={brandName}
            brandUrl={brandUrl}
            isInstock={isInstock}
            longProductDesc={longProductDesc[0]?.content}
            isPdp={isPdp}
            openVoucherList={openVoucherList}
            handleCloseVoucherList={handleCloseVoucherList}
            handleOpenVoucherList={handleOpenVoucherList}
            handleCopyVoucherCode={handleCopyVoucherCode}
            copied={copied}
            textToCopy={textToCopy}
            handleToggleDesc={handleToggleDesc}
            showFullDesc={showFullDesc}
            dataCouponList={dataCouponList}
            loadingCouponList={loadingCouponList}
            openModalStoreList={openModalStoreList}
            handleOpenModalStoreList={handleOpenModalStoreList}
            handleCloseModalStoreList={handleCloseModalStoreList}
            openModalProductLabelDesc={openModalProductLabelDesc}
            handleOpenModalProductLabelDesc={handleOpenModalProductLabelDesc}
            handleCloseModalProductLabelDesc={handleCloseModalProductLabelDesc}
            formatted_oms_stores={formatted_oms_stores}
            product={product}
            // eslint-disable-next-line react/jsx-no-bind
            generateStyle={generateStyle}
            selectedLabelIndex={selectedLabelIndex}
            openDialogProductCompare={openDialogProductCompare}
            setOpenDialogProductCompare={setOpenDialogProductCompare}
            widgetContentTop={widgetContentTop}
            widgetContentAside={widgetContentAside}
            loadingWidget={loadingWidget}
            amRewardEnabled={amRewardEnabled}
            showReward={showReward}
            showLinkRegistration={showLinkRegistration}
            dataStock={data_product}
            pickupStoresOMSLoading={pickupStoresOMSLoading}
            dataBrands={dataBrands}
            {...other}
        />
    );
};

export default ProductDetailAction;
